module.exports = __webpack_public_path__ + "static/media/ico-star.5760a362.svg";